import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmt } from "@/api";
import { JerseyBadge } from "@/components/Shared";
import { History, ChevronDown, ChevronUp } from "lucide-react";

export default function RecentResults() {
  const [heats, setHeats] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  const load = async () => {
    try {
      const data = await api.results();
      const flat = [];
      (data.divisions || []).forEach((d) =>
        (d.rounds || []).forEach((rnd) =>
          (rnd.heats || []).forEach((h) => {
            if (!h.is_live) flat.push(h);
          })
        )
      );
      flat.sort((a, b) => String(b.finished_at || "").localeCompare(String(a.finished_at || "")));
      setHeats(flat);
    } catch (e) {
      /* keep last */
    }
  };

  useEffect(() => {
    load();
    timer.current = setInterval(load, 10000);
    return () => clearInterval(timer.current);
  }, []);

  if (heats.length === 0) return null;
  const shown = open ? heats : heats.slice(0, 3);

  return (
    <div className="brutal p-4 mt-6" data-testid="recent-results">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="recent-results-toggle"
        className="w-full flex items-center gap-2 text-left"
      >
        <History size={22} className="shrink-0" />
        <h2 className="font-display text-xl font-black uppercase tracking-tight flex-1">Recent Results</h2>
        <span className="font-display text-xs uppercase tracking-widest text-gray-500">{heats.length} heats</span>
        {open ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>
      <p className="font-display text-[11px] uppercase tracking-widest text-gray-500 mt-1">Scores from heats already surfed</p>

      <div className="space-y-3 mt-3" data-testid="recent-results-list">
        {shown.map((h) => (
          <div key={h.id} className="brutal-2 p-3" data-testid={`recent-heat-${h.id}`}>
            <div className="font-display text-[11px] uppercase tracking-widest text-gray-500 mb-2">
              {h.division_name} · {h.round_name} · {h.name}
            </div>
            <div className="space-y-1.5">
              {h.leaderboard.map((r) => (
                <div key={r.rider_id} className="flex items-center gap-2">
                  <span className="font-score text-xl w-6 text-center text-gray-400">{r.rank}</span>
                  <JerseyBadge jersey={r.jersey} size="sm" />
                  <span className="font-display font-bold uppercase text-sm flex-1 min-w-0 truncate">{r.name}</span>
                  <span className="font-score text-2xl leading-none">{fmt(r.total)}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {!open && heats.length > 3 && (
        <button onClick={() => setOpen(true)} data-testid="recent-results-more" className="w-full mt-3 font-display font-black uppercase text-xs tracking-widest underline">
          Show all {heats.length} heats
        </button>
      )}
      <Link to="/results" data-testid="recent-results-link" className="block mt-3 brutal-2 bg-black text-white text-center py-2 font-display font-black uppercase text-xs tracking-widest">
        Full Results Board →
      </Link>
    </div>
  );
}
